import React from "react";

const Bed = ({
  width = 20,
  height = 20,
}: {
  width?: number;
  height?: number;
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.6665 12.5C1.6665 11.7234 1.6665 11.3351 1.79337 11.0289C1.96253 10.6205 2.28698 10.296 2.69536 10.1269C3.00165 10 3.38993 10 4.1665 10H15.8332C16.6097 10 16.998 10 17.3043 10.1269C17.7127 10.296 18.0371 10.6205 18.2063 11.0289C18.3332 11.3351 18.3332 11.7234 18.3332 12.5C18.3332 13.2766 18.3332 13.6649 18.2063 13.9711C18.0371 14.3795 17.7127 14.704 17.3043 14.8731C16.998 15 16.6097 15 15.8332 15H4.1665C3.38993 15 3.00165 15 2.69536 14.8731C2.28698 14.704 1.96253 14.3795 1.79337 13.9711C1.6665 13.6649 1.6665 13.2766 1.6665 12.5Z"
        stroke="#868C98"
        strokeWidth="1.5"
      />
      <path
        d="M17.5 9.9987C17.5 6.856 17.5 5.28465 16.5237 4.30834C15.5474 3.33203 13.976 3.33203 10.8333 3.33203H9.16667C6.02397 3.33203 4.45262 3.33203 3.47631 4.30834C2.5 5.28465 2.5 6.856 2.5 9.9987"
        stroke="#868C98"
        strokeWidth="1.5"
      />
      <path
        d="M15.4168 10.0013V8.7513C15.4168 7.17995 15.4168 6.39428 14.9287 5.90612C14.4405 5.41797 13.6548 5.41797 12.0835 5.41797H7.91683C6.34548 5.41797 5.55981 5.41797 5.07165 5.90612C4.5835 6.39428 4.5835 7.17995 4.5835 8.7513V10.0013"
        stroke="#868C98"
        strokeWidth="1.5"
      />
      <path d="M10 5.83203V9.9987" stroke="#868C98" strokeWidth="1.5" />
    </svg>
  );
};

export default Bed;
